// extracted by mini-css-extract-plugin
export var container = "ArContainer-module--container--Kop75";
export var full = "ArContainer-module--full--mI08J";